function autoInc(seed = 0) {
    return () => ++seed
}

export default autoInc()



// WEBPACK FOOTER //
// ./components/TextArea/uid.js